import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.5);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <>
      {/* Mobile: fixed bottom bar */}
      <div className="fixed inset-x-0 bottom-0 z-40 md:hidden">
        <div className="bg-card/95 backdrop-blur-lg border-t border-border shadow-[0_-8px_32px_rgba(0,0,0,0.3)]">
          <div className="max-w-xl mx-auto px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
            <Button
              asChild
              size="lg"
              className="w-full rounded-xl h-12 text-base font-semibold shadow-lg shadow-primary/30 hover:shadow-primary/40 hover:scale-[1.02] transition-all"
            >
              <Link to="/signup">
                Start free — no credit card
                <ArrowRight className="h-4 w-4 ml-1.5 shrink-0" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {/* Desktop: floating pill */}
      <div className="hidden md:block fixed bottom-6 right-6 z-40">
        <div className="flex items-center gap-4 bg-card/90 backdrop-blur-lg border border-border rounded-2xl px-5 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
          <span className="text-sm font-medium text-foreground whitespace-nowrap">
            Start free — no credit card
          </span>
          <Button
            asChild
            size="sm"
            className="rounded-xl font-semibold shadow-lg shadow-primary/25 hover:shadow-primary/35 transition-all"
          >
            <Link to="/signup">
              Get started
              <ArrowRight className="h-4 w-4 ml-1 shrink-0" />
            </Link>
          </Button>
        </div>
      </div>
    </>
  );
}
